const SEARCH_HISTORY_USER = "userSearchHistory";
const SEARCH_HISTORY_TEAM = "teamSearchHistory";
const MAX_HISTORY = 10;

/**
 * 🔹 검색어 추가 (최대 10개 유지)
 */
export const addSearchHistory = (term: string, target: string) => {
  if (!term || !target) {
    return;
  }

  let SEARCH_HISTORY_KEY = "";
  if (target === "user") {
    SEARCH_HISTORY_KEY = SEARCH_HISTORY_USER;
  } else if (target === "team") {
    SEARCH_HISTORY_KEY = SEARCH_HISTORY_TEAM;
  } else {
    return;
  }

  // 기존 검색 기록 가져오기
  let history: string[] = JSON.parse(localStorage.getItem(SEARCH_HISTORY_KEY) || "[]");

  // 기존에 있던 검색어 삭제 후 맨 앞으로 추가
  history = history.filter((item) => item !== term);
  history.unshift(term);

  // 최대 개수 초과 시 마지막 항목 삭제
  if (history.length > MAX_HISTORY) {
    history.pop();
  }

  // 업데이트된 검색 기록 저장
  localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(history));
};

/**
 * 🔹 검색 기록 가져오기
 */
export const getSearchHistory = (target: string): string[] => {
  if (!target) {
    return [];
  }

  let SEARCH_HISTORY_KEY = "";
  if (target === "user") {
    SEARCH_HISTORY_KEY = SEARCH_HISTORY_USER;
  } else if (target === "team") {
    SEARCH_HISTORY_KEY = SEARCH_HISTORY_TEAM;
  } else {
    return [];
  }

  return JSON.parse(localStorage.getItem(SEARCH_HISTORY_KEY) || "[]");
};

/**
 * 🔹 특정 검색어 삭제
 */
export const removeSearchHistory = (term: string, target: string) => {
  if (!term || !target) {
    return;
  }

  let SEARCH_HISTORY_KEY = "";
  if (target === "user") {
    SEARCH_HISTORY_KEY = SEARCH_HISTORY_USER;
  } else if (target === "team") {
    SEARCH_HISTORY_KEY = SEARCH_HISTORY_TEAM;
  } else {
    return;
  }

  let history: string[] = JSON.parse(localStorage.getItem(SEARCH_HISTORY_KEY) || "[]");

  // 검색어 제거 후 업데이트
  history = history.filter((item) => item !== term);
  localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(history));
};
